export class TemplateChoiceInspectionInput {
    description = '';
    constructor(choiceInspection) {
        if (choiceInspection) {
            this.description = choiceInspection.description;
        }
    }
}
